<app-header></app-header>

<div class="container">
<div [innerHTML]="html">
</div>
</div>


